import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFortyTwoPreLogin',
    name: 'IFPageOneHFortyTwoPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFortyTwoLogin' ||
        from.path === '/IFPageOneHFortyTwoLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFortyTwoLogin',
    name: 'pageOneHFortyTwoLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/login.vue'),
  },
  {
    path: '/IFPageOneHFortyTwoLoginLoading',
    name: 'pageOneHFortyTwoLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFortyTwoLeaveInfo',
    name: 'pageOneHFortyTwoLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFortyTwoResult',
    name: 'pageOneHFortyTwoResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/result.vue'),
  },
  {
    path: '/IFPageOneHFortyTwoLoading',
    name: 'pageOneHFortyTwoLoading',
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFortyTwoLoginSecond',
    name: 'pageOneHFortyTwoLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyTwoOnline',
    name: 'pageOneHFortyTwoOnline',
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFortyTwoLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFortyTwoGuide',
    name: 'pageOneHFortyTwoLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHFortyTwoCar',
    name: 'pageOneHFortyTwoCar',
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFortyTwoCarDetails',
    name: 'pageOneHFortyTwoCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHFortyTwoBlank',
    name: 'pageOneHFortyTwoBlank',
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyTwoOnlineTab',
    name: 'pageOneHFortyTwoOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyTwoOnlineAd',
    name: 'pageOneHFortyTwoOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFortyTwo/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
